import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import { useAuth } from "hooks";
import { GET_MISSION_ROLE_APPLICANTS, GET_NOT_SELECTED_APPLICATION_REASONS } from "graphql/queries";
import { UNSELECT_APPLICANT } from "graphql/mutations";
import { MUTATION_TYPE, useToast } from "hooks";
import { margins } from "style";
import { MODAL_SIZE, ModalForm } from "components/Modal";
import { TYPE } from "components/Form";
import { getNotificationPreferenceCheckboxItem } from "components/Notification";

/**
 * ApplicantNotSelectedForm
 *
 * @param {Boolean} show
 * @param {Array} applicantIds
 * @param {Function} onClose
 * @param {Function} handleToastMessages
 */
const ApplicantNotSelectedModal = ({ show, applicantIds, onClose, handleToastMessages, ...props }) => {
  const { toast } = useToast();
  const { isAdmin } = useAuth();

  const handleComplete = (data) => {
    onClose();
    const unselected = data?.unselectMissionRoleApplicants?.unselected || [];
    const failedToUnselect = data?.unselectMissionRoleApplicants?.failedToUnselect || [];

    handleToastMessages(
      unselected,
      failedToUnselect,
      "Missions.Applicants.ApplicantAdvancedOptions.SuccessNotSelected",
      "Missions.Applicants.ApplicantAdvancedOptions.Error",
      "Missions.Applicants.ApplicantAdvancedOptions.PartiallyNotSelected"
    );
  };

  const handleError = () => {
    toast.error(<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.Error" />);
  };

  return (
    <ModalForm
      initialValues={{ shouldNotify: isAdmin }}
      data={getFormData(isAdmin)}
      title={<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.NotSelectedModal.Title" />}
      description={<FormattedMessage id="Missions.Applicants.ApplicantAdvancedOptions.NotSelectedModal.Desc" />}
      marginSize={margins.xxsmall}
      show={show}
      onClose={onClose}
      size={MODAL_SIZE.small}
      updateId={applicantIds}
      onCompleted={handleComplete}
      onError={handleError}
      mutationType={MUTATION_TYPE.update}
      mutationData={{
        mutationName: {
          update: UNSELECT_APPLICANT,
        },
        refetchAfterMutate: true,
        refetchQueries: [GET_MISSION_ROLE_APPLICANTS],
      }}
      {...props}
    />
  );
};

const getFormData = (isAdmin) => [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        type: TYPE.tags,
        properties: {
          name: "notSelectedReasons",
          placeholder: "Select reasons",
          queryName: GET_NOT_SELECTED_APPLICATION_REASONS,
          queryKeyName: "notSelectedApplicationReasons",
          minLength: 0,
          required: true,
        },
      },
      isAdmin && getNotificationPreferenceCheckboxItem({ name: "shouldNotify" }),
    ].filter(Boolean),
  },
];

ApplicantNotSelectedModal.propTypes = {
  show: PropTypes.bool.isRequired,
  applicantIds: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  handleToastMessages: PropTypes.func.isRequired,
};

export default ApplicantNotSelectedModal;
